import React from 'react';
import { Link } from 'react-router-dom';

const seoLinks = [
  ['/homes-for-sale-flint-mi', 'Homes for Sale Flint MI'],
  ['/flint-mi-real-estate-agent', 'Flint MI Realtor'],
  ['/buy-a-home-in-flint-michigan', 'Buy a Home'],
  ['/sell-my-house-flint-mi', 'Sell My House'],
  ['/first-time-home-buyer-flint', 'First Time Buyers'],
  ['/flint-mi-investment-properties', 'Investment Properties'],
  ['/genesee-county-real-estate', 'Genesee County'],
  ['/flint-mi-home-values', 'Home Values'],
  ['/houses-for-rent-flint-mi', 'Rentals'],
  ['/flint-michigan-neighborhoods', 'Neighborhoods'],
  ['/fenton-mi-homes-for-sale', 'Fenton Homes'],
  ['/burton-mi-real-estate', 'Burton Real Estate'],
  ['/swartz-creek-homes-for-sale', 'Swartz Creek'],
  ['/clio-mi-real-estate', 'Clio Real Estate'],
  ['/flushing-mi-homes-for-sale', 'Flushing Homes'],
  ['/linden-mi-real-estate', 'Linden Real Estate'],
  ['/flint-mi-foreclosures', 'Foreclosures'],
  ['/flint-mi-open-houses', 'Open Houses'],
  ['/relocating-to-flint-michigan', 'Relocating Guide'],
  ['/flint-mi-luxury-homes', 'Luxury Homes'],
];

const resourceLinks = [
  ['/', 'Home'],
  ['/properties/list', 'Property Search'],
  ['/blogs', 'Blog'],
  ['/reviews', 'Reviews'],
  ['/contact-us', 'Contact Us'],
  ['/agent', 'About David'],
  ['/privacy-policy', 'Privacy Policy'],
  ['/terms-of-service', 'Terms of Service'],
];

export default function SEOFooter() {
  const linkColor = '#8ab4f8';

  return (
    <footer style={{ background: '#1a1a2e', color: '#ccc', padding: '24px 16px 12px', fontSize: '12px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', maxWidth: '1200px', margin: '0 auto' }}>
        <div>
          <h4 style={{ margin: '0 0 8px', fontSize: '13px', color: '#fff' }}>Flint Area Real Estate</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px 12px' }}>
            {seoLinks.map(([to, label]) => (
              <Link key={to} to={to} style={{ color: linkColor, textDecoration: 'none', lineHeight: '1.8' }}>{label}</Link>
            ))}
          </div>
        </div>
        <div>
          <h4 style={{ margin: '0 0 8px', fontSize: '13px', color: '#fff' }}>Resources</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px 12px' }}>
            {resourceLinks.map(([to, label]) => (
              <Link key={to} to={to} style={{ color: linkColor, textDecoration: 'none', lineHeight: '1.8' }}>{label}</Link>
            ))}
          </div>
        </div>
      </div>
      <p style={{ textAlign: 'center', marginTop: '16px', color: '#999', fontSize: '11px' }}>
        © 2026 David Hamady | HamadyRobinson, REALTORS® | (810) 814-0490
      </p>
    </footer>
  );
}
